import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Plus, Trash2, Check } from 'lucide-react';
import { confirmDialog } from '../ConfirmHost';
import { API, errText } from './docLibShared';

const Row = ({ c, onChanged }) => {
  const [name, setName] = useState(c.name);
  const save = async () => {
    try { await axios.put(`${API}/doc-library/categories/${c.id}`, { name, order: c.order || 0 }); toast.success('Kategori güncellendi'); onChanged(); } catch (e) { toast.error(errText(e)); }
  };
  const remove = async () => {
    if (!(await confirmDialog({ title: 'Kategori silinsin mi?', description: `"${c.name}" kategorisi silinecek.`, confirmLabel: 'Evet, Sil' }))) return;
    try { await axios.delete(`${API}/doc-library/categories/${c.id}`); toast.success('Kategori silindi'); onChanged(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="flex items-center gap-2" data-testid={`doc-cat-row-${c.id}`}>
      <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={`doc-cat-name-${c.id}`} />
      <Button size="icon" variant="ghost" className="text-emerald-600" disabled={!name.trim() || name === c.name} onClick={save} data-testid={`doc-cat-save-${c.id}`}><Check className="h-4 w-4" /></Button>
      <Button size="icon" variant="ghost" className="text-rose-600" onClick={remove} data-testid={`doc-cat-delete-${c.id}`}><Trash2 className="h-4 w-4" /></Button>
    </div>
  );
};

export const DocCategoriesDialog = ({ open, categories, onClose, onChanged }) => {
  const [name, setName] = useState('');
  const add = async () => {
    try { await axios.post(`${API}/doc-library/categories`, { name, order: categories.length }); setName(''); toast.success('Kategori eklendi'); onChanged(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="doc-cat-dialog">
        <DialogHeader><DialogTitle>Doküman Kategorileri</DialogTitle></DialogHeader>
        <div className="flex gap-2">
          <Input placeholder="Örn. Prosedürler, Formlar, Talimatlar" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && name.trim() && add()} data-testid="doc-cat-new-input" />
          <Button onClick={add} disabled={!name.trim()} data-testid="doc-cat-add-btn"><Plus className="h-4 w-4 mr-1" />Ekle</Button>
        </div>
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {categories.length === 0 ? <p className="text-sm text-slate-500 py-4 text-center">Henüz kategori yok.</p> : categories.map(c => <Row key={c.id + c.name} c={c} onChanged={onChanged} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
